<script lang="ts" setup>
    type Refinement = {
        type: 'facet' | 'exclude' | 'disjunctive' | 'hierarchical' | 'numeric' | 'query';
        /**
         * The name of the attribute where the refinement is applied. The value is used as the key.
         */
        attribute: string;
        /**
         * The name of the attribute with which the refinement is applied. The label is used as the the display value.
         */
        label: string;
        /**
         * Actual value for this refinement.
         */
        value: any;
    };

    /**
     * https://www.algolia.com/doc/api-reference/widgets/current-refinements/vue#param-default => items
     */
    type RefinementItem = {
        /**
         * The index name on which the refinement is applied.
         */
        indexName: string;
        /**
         * The index id on which the refinement is applied.
         */
        indexId: string;
        /**
         * The name of the attribute with which the refinement is applied. The value is used as the key.
         */
        attribute: string;
        /**
         * The name of the attribute with which the refinement is applied. The label is used as the the display value.
         */
        label: string;
        /**
         * The function to clear a refinement.
         */
        refine: (value: Refinement) => void;
        refinements: Refinement[];
    };
    interface AlgoliaCurrentRefinementsProps {
        items: RefinementItem[];
        categoryName: string;
        createURL: (item: Refinement) => string;
        t: (key: string) => string;
        handleCurrentRefinementValue: (type: string, value: string) => string;
    }

    defineProps<AlgoliaCurrentRefinementsProps>();
</script>
<template>
    <!-- text-woom-black needed to override algolia styles  -->
    <ul class="atm-algolia-current-refinements flex flex-wrap text-xs text-woom-black max-lg:flex-col lg:gap-4">
        <li
            class="relative flex flex-wrap items-center gap-2 rounded-none max-lg:w-full max-lg:py-3"
            v-for="item in items"
            :key="item.attribute">
            <span class="font-bold capitalize">{{ t(item.label.replace('hierarchicalCategories.lvl0', categoryName)) }}</span>
            <ul class="contents">
                <li
                    class="my-auto flex shrink-0 gap-2 rounded-sm border border-woom-grey-taupe bg-woom-white-smoke"
                    v-for="refinement in item.refinements"
                    :key="refinement.attribute">
                    <a
                        :href="createURL(refinement)"
                        @click.prevent="item.refine(refinement)"
                        class="flex items-center gap-2 px-2 py-1">
                        <span>
                            {{ handleCurrentRefinementValue(item.label.replace('hierarchicalCategories.lvl0', 'category'), t(refinement.label)) }}
                        </span>
                        <woom-icon-close class="size-4 fill-current" />
                    </a>
                </li>
            </ul>
        </li>
    </ul>
</template>
